/* eslint implicit-arrow-linebreak: 0 */

import _some from 'lodash/some';
import _curry from 'lodash/curry';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// Readers
import filterGroupReader from '../../readers/FilterGroup';
var getRowValue = function getRowValue(params, rowId) {
  return _get(params, "values.".concat(rowId));
};
var getSavedRowValue = function getSavedRowValue(params, index) {
  var selectedFilterGroup = params.selectedFilterGroup;
  var filters = filterGroupReader.filters(selectedFilterGroup) || EMPTY_ARRAY;
  var savedRowValue = filters[index];
  return savedRowValue;
};
var isRowModified = _curry(function (params, rowId, index) {
  var currentRowValue = getRowValue(params, rowId);
  var savedRowValue = getSavedRowValue(params, index);
  return !_isEqual(currentRowValue, savedRowValue);
});
var isFilterGroupModified = function isFilterGroupModified() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_ARRAY;
  var selectedFilterGroup = params.selectedFilterGroup;
  if (rows.length !== _get(selectedFilterGroup, 'filters.length')) {
    return true;
  }
  return _some(rows, isRowModified(params));
};
export default isFilterGroupModified;